module.exports = __webpack_public_path__ + "img/plugin-item.e958add3.jpg";